var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3714_54169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04309 9.65771C5.27905 10.1393 6.14363 10.7224 7.06386 12.7469C8.03677 14.8873 9.74676 15.521 10.8596 15.521",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.33 1.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46521 9.51904C9.46521 7.86438 10.8115 6.51807 12.4662 6.51807C14.1208 6.51807 15.4672 7.86438 15.4672 9.51904C15.4672 12.1098 12.725 15.3205 12.6082 15.4559C12.5725 15.4972 12.5243 15.5171 12.4662 15.521C12.4122 15.521 12.3608 15.4977 12.3251 15.457C12.2083 15.3239 9.46521 12.1663 9.46521 9.51904Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.4631,
    cy: 9.63818,
    r: 1.16797,
    stroke: "currentColor",
    strokeWidth: 0.744244
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.532959 3.42664C0.532959 1.95888 1.72719 0.764648 3.19495 0.764648C4.6627 0.764648 5.85693 1.95888 5.85693 3.42664C5.85693 5.72476 3.42454 8.57276 3.32089 8.69288C3.28928 8.72948 3.24652 8.74712 3.19495 8.75061C3.14703 8.75061 3.10144 8.72998 3.06983 8.69388C2.96618 8.57575 0.532959 5.77484 0.532959 3.42664Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.19229,
    cy: 3.53262,
    r: 1.03604,
    stroke: "currentColor",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3714_54169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.142578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripOutline);
export default __webpack_public_path__ + "static/media/trip-outline.60144cd02d1eedee601862a82fe13d22.svg";
export { ForwardRef as ReactComponent };